import { Dialog } from '@material-ui/core';
import React, { useState } from 'react';
import { VideoCameraIcon, VideoCameraSlashIcon, XMarkIcon } from '@heroicons/react/24/outline';
import SquaredButton from 'shared/components/SquaredButton';
import { updateCamera } from '@/app/services/camera';
import * as Actions from 'app/store/actions';
import { useDispatch } from 'react-redux';

const EditCameraStatusModal = ({ open, onClose, camera, onSuccess }) => {
	const dispatch = useDispatch();
	const [submitting, setSubmitting] = useState(false);

	const handleSubmit = () => {
		setSubmitting(true);
		const payload = {
			active: !camera?.active,
			admin: camera?.admin,
			room_id: camera?.room?.id,
			facelink: camera?.facelink,
			family: camera?.family,
			camera_id: camera?.camera_id,
		};
		updateCamera(camera?.id, payload)
			.then(() => {
				setSubmitting(false);
				dispatch(
					Actions.showMessage({
						message: 'Camera status updated successfully',
						variant: 'success',
					})
				);
				onSuccess?.(); // Call the refresh callback if provided
				onClose();
			})
			.catch((error) => {
				setSubmitting(false);
				dispatch(
					Actions.showMessage({
						message: error?.response?.data?.message || 'Failed to update camera status',
						variant: 'error',
					})
				);
			});
	};
	return (
		<Dialog
			classes={{
				paper: 'w-[90%] max-w-[400px] m-8 rounded-[12px] p-24',
			}}
			onClose={onClose}
			open={open}
		>
			<div className="flex flex-col">
				<div className="flex justify-between items-start mb-16">
					<div className="flex items-center gap-16">
						<div
							className={`p-12 rounded-[12px] ${
								camera?.active ? 'bg-error-secondary' : 'bg-white border border-pd-blue'
							}`}
						>
							{camera?.active ? (
								<VideoCameraSlashIcon className="size-24 text-error" />
							) : (
								<VideoCameraIcon className="size-24 text-pd-blue" />
							)}
						</div>
					</div>
					<button
						className="p-8 absolute top-8 right-8 hover:bg-grey-100 rounded-full"
						onClick={onClose}
						type="button"
					>
						<XMarkIcon className="w-24 h-24 text-[#A4A7AE]" />
					</button>
				</div>
				<div className="mb-32">
					<h2 className="font-inter text-18 font-semibold leading-[28px]">
						{camera?.active ? 'Disconnect Camera' : 'Connect Camera'}
					</h2>
					<p className="text-14 text-gray-800 leading-[20px]">
						{camera?.active
							? `You are about to disconnect the camera ${camera?.camera_id}.`
							: `You are about to connect the camera ${camera?.camera_id}.`}
					</p>
				</div>
				<div className="flex w-full gap-16 mt-32">
					<SquaredButton onClick={onClose} size="full" type="button" variant="outline">
						Cancel
					</SquaredButton>
					<SquaredButton
						disabled={submitting}
						onClick={handleSubmit}
						size="full"
						type="submit"
						variant={camera?.active ? 'error' : 'filled'}
					>
						{camera?.active ? 'Disconnect' : 'Connect'}
					</SquaredButton>
				</div>
			</div>
		</Dialog>
	);
};

export default EditCameraStatusModal;
